import { render, staticRenderFns } from "./resourceUpdate.vue?vue&type=template&id=41035087&"
import script from "./resourceUpdate.vue?vue&type=script&lang=js&"
export * from "./resourceUpdate.vue?vue&type=script&lang=js&"
import style0 from "./resourceUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports